// config/detailActions.config.ts

import {
  CreditCard,
  ExternalLink,
  Bell,
  Printer,
} from "lucide-react";

export const detailActions = [
  {
    key: "register-payment",
    title: "Registrar pago",
    icon: CreditCard,
    variant:
      "border-primary/30 bg-primary/5 text-primary hover:bg-primary/10",
    featured: true,
  },
  {
    key: "account-status",
    title: "Descargar detalle de cuenta",
    icon: Printer,
    variant:
      "border-meta-3/20 bg-meta-3/5 text-meta-3 hover:bg-meta-3/10",
  },
  {
    key: "view-sale-origin",
    title: "Ver venta origen",
    icon: ExternalLink,
    variant:
      "border-meta-5/20 bg-meta-5/5 text-meta-5 hover:bg-meta-5/10",
  },
  {
    key: "send-reminder",
    title: "Enviar recordatorio",
    icon: Bell,
    variant:
      "border-warning/20 bg-warning/5 text-warning hover:bg-warning/10",
  },
];